import { IPercentagesProps } from "../../../Interfaces/IPercentagesProps";
import { CalcColumns } from "../../../Static/AnalysisColumns";
import CustomTableComponent from "../../Shared/CustomTable";

interface TablePercentagesComponentProps {
    rowPercentages: IPercentagesProps[]
}

const TablePercentagesComponent = (props: TablePercentagesComponentProps) => {
    return (
        <div>
            <CustomTableComponent
                rows={props.rowPercentages}
                hasHeader={false}
                columns={CalcColumns}
                isTableInverted={true}
                containsIconsWithValidation={true}
            />
        </div>
    )
}

export default TablePercentagesComponent;